module.exports = __webpack_public_path__ + "img/icon-4.4c4a0466.png";